(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blob-btn"] && !Shopify.designMode) return;
  try {
    class BlobBtn extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      const blob = this.querySelector('.blob-btn-wrap')
      const button = blob.querySelector('button, a')
      const onMouseMove = e => {
        const rect = blob.getBoundingClientRect()
        blob.style.setProperty('--btn-cur-x', `${e.clientX - rect.left}px`)
        blob.style.setProperty('--btn-cur-y', `${e.clientY - rect.top}px`)
      }
      const onMouseEnter = e => {
        blob.classList.add('is-active')
      }
      const onMouseLeave = e => {
        blob.classList.remove('is-active')
      }
      const io = new IntersectionObserver(entries => {
        const el = entries[0]
        if (el.isIntersecting) {
          document.addEventListener('mousemove', onMouseMove)
          button.addEventListener('mouseenter', onMouseEnter)
          button.addEventListener('mouseleave', onMouseLeave)
        } else {
          blob.style.removeProperty('--btn-cur-x')
          blob.style.removeProperty('--btn-cur-y')
          blob.classList.remove('is-active')
          document.removeEventListener('mousemove', onMouseMove)
          button.removeEventListener('mouseenter', onMouseEnter)
          button.removeEventListener('mouseleave', onMouseLeave)
        }
      })
      io.observe(blob)
    }
  }

  customElements.define('blob-btn', BlobBtn)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sign-up"] && !Shopify.designMode) return;
  try {
    class SignUp extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      const form = this.querySelector('.form')
      const message = this.querySelector('.message')
      const submitEmail = async (url, body) => {
        try {
          await fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          })
        } catch (err) {
          console.error(err)
        }
        form.classList.add('!hidden')
        message.classList.add('!flex')
      }
      form.addEventListener('submit', e => {
        e.preventDefault()
        const baseUrl =
          'https://api.hsforms.com/submissions/v3/integration/submit'
        const portalId = '50157338'
        const formId = '5f29642f-1c84-4697-b6b7-33c5b47eb4dc'
        const requestUrl = `${baseUrl}/${portalId}/${formId}`
        const email = form.querySelector('input[type="email"]').value
        const body = {
          submittedAt: new Date().getTime(),
          fields: [
            {
              objectTypeId: '0-1',
              name: 'email',
              value: email,
            },
          ],
        }
        submitEmail(requestUrl, body)
      })
    }
  }

  customElements.define('sign-up', SignUp)
  } catch(e) { console.error(e); }
})();

})();
